import { dancerAnimations } from './DancerAnimations';

const ChestAnimationNames = {
  close: 'close',
  shake: 'shake',
  open: 'open',
  static: 'static',
  open_static: 'open_static',
};

const ChestAnimationDurations = {
  close: -1,
  shake: -1,
  open: -1.5,
  static: null,
  open_static: null,
};

class ChestAnimations {
  constructor() {
    this.animations = {};
    this.isCleared = false;
  }

  setupAnimations(texture) {
    this.texture = texture;
    Object.values(ChestAnimationNames).forEach((name) => {
      this.animations[name] = (delay = 0, loop = false) => {
        return new Promise((resolve) => {
          texture.state.addAnimation(0, name, loop, delay);
          texture.state.addListener({
            complete(entry) {
              resolve(entry);
            },
          });
        });
      };
    });
  }

  startCloseAnimation(delay, loop) {
    this.clearCloseTrack();
    dancerAnimations.startCloseAnimation();
    return this.animations[ChestAnimationNames.close](delay, loop);
  }

  startOpenAnimation(delay, loop) {
    // if (!this.isCleared) {
    this.clearOpenTrack();
    if (delay < ChestAnimationDurations.open) {
      return this.startOpenStaticAnimation();
    }
    return this.animations[ChestAnimationNames.open](delay, loop);
    // }
  }

  clearChestAnimations() {
    this.clearTracks();
  }

  startStaticAnimation(delay, loop) {
    // if (!this.isCleared) {
    return this.animations[ChestAnimationNames.static](delay, loop);
    // }
  }

  startOpenStaticAnimation(delay, loop) {
    return this.animations[ChestAnimationNames.open_static](delay, loop);
  }

  startShakeAnimation(delay, loop) {
    return this.animations[ChestAnimationNames.shake](delay, loop);
  }

  // eslint-disable-next-line class-methods-use-this
  clearTracks() {
    if (this.texture) {
      // this.texture.skeleton.setToSetupPose();
      // console.log('cleared');
      // this.texture.state.trackEntryPool.items = [];
      // this.texture.state.clearListeners();
      this.texture.state.clearTracks();

      this.texture.state.setEmptyAnimations(0);
      this.texture.skeleton.setToSetupPose();
      this.texture.state.apply(this.texture.skeleton);
      this.startStaticAnimation();
      this.setIsCleared(true);
    }
  }

  setIsCleared(bool) {
    this.isCleared = bool;
  }

  clearOpenTrack() {
    if (this.texture.state.tracks[0]?.animation.name === 'open') {
      this.texture.state.clearTracks();
    }
  }

  clearCloseTrack() {
    if (this.texture.state.tracks[0]?.animation.name === 'close') {
      this.texture.state.clearTracks();
      this.startStaticAnimation();
    }
  }
}

export const chestAnimations = new ChestAnimations();
window.chestAnimations = chestAnimations;
